import { render, staticRenderFns } from "./Asset.vue?vue&type=template&id=6b24c16d"
import script from "./Asset.vue?vue&type=script&lang=js"
export * from "./Asset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports